// extracted by mini-css-extract-plugin
export default {"image":"FormManuallyAddAccount_image__ujQee"};